export default __webpack_public_path__ + "static/media/editicon.06aa3c84.svg";